<fa-icon
    [class]="isInherited() ? 'text-custom-dark-grey' : 'text-black'"
    [icon]="icon()"
    [matTooltip]="tooltip()"
    [matTooltipDisabled]="!tooltip()"
    [size]="size()"
    [style.cursor]="cursor()"
    (click)="onClick()" />
